function linkBoxes() {
   

    const cards = document.querySelectorAll('.event_card'); 
    if(cards.length){
        cards.forEach(card=>{
            card.style.cursor = 'pointer';
            let link = card.querySelector('.event_target');
            card.addEventListener('click', ()=>{
                link.click();
            });
        });
    } 

  }

  window.addEventListener("load", function () {
      linkBoxes();
  });

  document.addEventListener("DOMContentLoaded",add_title_to_links);

  function add_title_to_links(){

    let link_blocks = document.querySelectorAll('.add_title_to_button');
    
    if(link_blocks.length==0) return;
    link_blocks.forEach(block=>{
        let links = block.querySelectorAll('a.vc_btn3');
        let title = block.previousElementSibling.firstElementChild;
        console.log(title);
        if(!title||!title.classList.contains('add_title_to_button_source')) return;
        title=title.querySelector('h3').innerText; 
        links.forEach(link=>{
            let span = document.createElement('span');
            span.innerText = ` for ${title}`;
            span.classList.add('screen-reader-text');
            link.append(span);
        })
    });
  }